module.exports = __webpack_public_path__ + "13122a3e3de6e158632a21bb6569d3fe.svg";